var map = {
	"./icon-cont-1.png": "ebdf",
	"./icon-cont-2.png": "6c09",
	"./icon-cont-3.png": "b993",
	"./icon-cont-4-.png": "2e0c",
	"./icon-cont-4.png": "8b5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db70";